module.exports = __webpack_public_path__ + "media/images/map/location-work-4d8c65aae3b11706a0e0d9633776d7ca.svg";